import React from "react";
import useAxios from "axios-hooks";
import classNames from "classnames";

import Api from "../../api";
import SeoBlock from "../../components/seo_block/SeoBlock";
import { Customers, Awards, Gallery } from "../../components";
import { Membership } from "../../includes";
import { useCorrectCustomers } from "../../hooks";
import { Section } from "../../layouts";
import { request } from "../../api";


import styles from "./About.module.scss";

const About = ({ contact }) => {

  const [{ data, loading, error }] = useAxios({ url: Api.page_about });

  const correctCustomers = useCorrectCustomers(data?.customers);

  const page = data ? data.page : {};
  const thumbs =
    data &&
    data.about_thumbs.length > 0 &&
    data.about_thumbs.map((item, index) => {
      return (
        <div key={index}>
          <div className={styles.aboutWrapper}>
            {item.video?.url ? (
              <video
                loop={true}
                muted={true}
                preload={true}
                playsInline
                autoPlay={true}
              >
                <source src={`${request}/${item.video.url}`} type="video/mp4" />
              </video>
            ) : item?.image?.thumb?.url ? (
              <img
                className={styles.aboutMoreImage}
                src={`${request}/${item.image.thumb.url}`}
                alt=""
              />
            ) : (
              <></>
            )}
          </div>

          <h3 className={styles.aboutMoreTitle}>{item.title}</h3>
          <p className={styles.aboutMoreInfo} dangerouslySetInnerHTML={{ __html: item.description }} ></p>
        </div>
      );
    });

  const awards = data && data.awards.length > 0 && data.awards;

  const seo = data ? data.seo : {};
  const contact_in = contact && contact.city_in;
  const h1Title = seo?.seo_h1 ? (
    <div className="holder wrap">
      <h1 className="h2-title">
        {seo.seo_h1.includes("#CITY_ROD#")
          ? seo.seo_h1.replace("#CITY_ROD#", contact_in)
          : seo.seo_h1}
      </h1>
    </div>
  ) : (
    ""
  );

  const splittingArray = (arr) => {
    const separatorIndex = Math.floor(arr.length / 2); // 3

    const secondArray = [...arr];
    const firstArray = secondArray.splice(0, separatorIndex);

    return { firstArray, secondArray };
  };

  return (
    <div className="pageAbout main-container  main-container_large-top-indent">
      <SeoBlock data={seo} contact={contact} />

      {h1Title && h1Title}

      {page && (
        <div className="holder wrap no-pdn-top">
          <div className={styles.Hero}>
            {page.headbody && (
              <div
                dangerouslySetInnerHTML={{ __html: page.headbody }}
                className={classNames("new-content", styles.aboutDescription)}
              ></div>
            )}

            {page.image && page.image.url && (
              <img
                className={styles.aboutMainImage}
                src={`${request}/${page.image.thumb_long.url}`}
                alt={page.title}
              />
            )}
          </div>
        </div>
      )}

      {thumbs && (
        <Section className={styles.aboutMoreWrap}>
          <div className={styles.aboutMore}>{thumbs}</div>
        </Section>
      )}

      <Section className="section">
          <Membership />
      </Section>

      {/* {page && page.file && page.file.url && (
        <Section className="section">
          <div className={styles.aboutPresentation}>
            <h2 className={classNames("h2-title", styles.AboutTitle)}>
              Презентация нашего агентства с&nbsp;нашими самыми интересными проектами.
            </h2>

            <Button
              href={`${request}/${page.file.url}`}
              target="_blank"
              className={styles.Button}
            >
              Скачать презентацию
            </Button>
          </div>
        </Section>
      )} */}

      {data && data.about_slides.length > 0 && (
        <section>
          {data.about_slides.length < 6 ? (
            <Gallery
              className={styles.Gallery}
              images={data.about_slides}
              speed={50000}
            />
          ) : (
            <>
              <Gallery
                className={styles.Gallery}
                images={splittingArray(data.about_slides).firstArray}
                speed={50000}
              />
              <Gallery
                className={styles.Gallery}
                images={splittingArray(data.about_slides).secondArray}
                speed={50000}
                reverse
              />
            </>
          )}
        </section>
      )}

      <section className="sections-list">
        {correctCustomers?.length > 0 && (
          <div>
            <Section className="section">
              <Customers
                titleClassName={styles.CustomersTitle}
                customers={correctCustomers}
                title="Нам важно создавать работающие и&nbsp;эффективные решения в&nbsp;области маркетинга,
                рекламы и&nbsp;дизайна. Это правило лежит в&nbsp;основе всех наших проектов."
              />
            </Section>
          </div>
        )}

        {awards?.length > 0 && (
          <div>
            <Section className="section">
              <Awards list={awards} title="Наши награды" />
            </Section>
          </div>
        )}
      </section>
    </div>
  );
};

export default About;
